import request from '@/config/axios'

/**
 * 数据统计（漏斗 / 日趋势 / 成本）
 *
 * 注意：`funnel` 与 `summary` 后端是**同一 Service 方法的两个视图**，
 * 返回结构完全一致（均为 `ActivityStatFunnelRespVO`），不要以为是两套数据。
 * 2026-09-16 营销中心合并开发 P4
 */

/** 漏斗统计 VO（对应后端 ActivityStatFunnelRespVO，summary 同构） */
export interface ActivityStatFunnelVO {
  activityId?: number
  pvCount?: number
  uvCount?: number
  joinCount?: number
  joinMemberCount?: number
  awardCount?: number
  shareCount?: number
  shareOpenCount?: number
  /** 奖品成本（分） */
  costAmount?: number
  /** 参与率 = 参与人次 / 访问量 */
  joinRate?: number
  /** 中奖率 = 中奖人次 / 参与人次 */
  awardRate?: number
}

/** 日趋势 VO（对应后端 ActivityStatTrendRespVO） */
export interface ActivityStatTrendVO {
  id?: number
  activityId?: number
  statDate?: string
  pvCount?: number
  uvCount?: number
  joinCount?: number
  joinMemberCount?: number
  newMemberCount?: number
  awardCount?: number
  shareCount?: number
  shareOpenCount?: number
  costAmount?: number
}

/** 获得活动漏斗（访问→参与→中奖→分享回流） */
export function getStatFunnel(activityId: number) {
  return request.get({ url: '/promotion/activity-stat/funnel', params: { activityId } })
}

/** 获得活动汇总（与 funnel 同源） */
export function getStatSummary(activityId: number) {
  return request.get({ url: '/promotion/activity-stat/summary', params: { activityId } })
}

/** 获得日趋势 */
export function getStatTrend(activityId: number, days = 30) {
  return request.get({ url: '/promotion/activity-stat/trend', params: { activityId, days } })
}

/** 重建某日快照（定时任务缺失时的人工兜底；statDate 默认昨天） */
export function refreshStat(activityId: number, statDate?: string) {
  return request.post({ url: '/promotion/activity-stat/refresh', params: { activityId, statDate } })
}

/** 导出日趋势 Excel */
export function exportStat(activityId: number, days = 30) {
  return request.download({ url: '/promotion/activity-stat/export', params: { activityId, days } })
}
